export default __webpack_public_path__ + "static/mobile_landing-bf-2895f1b8a814944505f19bbc10db7205.png";